<template>
  <v-dialog v-model="visible" persistent fullscreen>
    <v-card height="100%">
      <v-card-title class="pa-0">
        <v-toolbar class="primary" dark dense flat>
          <v-toolbar-title>
            {{ parking.name }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>

      <parking-common :parking="parking" :access-code="booking.accessCode">
        <template v-if="userHasErrors">
          <v-card flat height="auto">
            <v-container>
              <v-layout row wrap class="mb-1">
                <v-flex xs12>
                  <advice color="error" class="mb-4">
                    <p
                      class="subheading grey--text grey--ar-1 ma-0"
                      v-html="$t(`user.error.booking.${userErrorText}`)"
                    ></p>
                  </advice>
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn
                    outline
                    color="accent"
                    class="initialize"
                    round
                    @click="solveUserError"
                  >
                    {{ $t('global.solve') }}
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </template>
        <template v-else>
          <booking-edit
            v-if="showingReservationEdit"
            :parking="parking"
            :booking-data="booking"
            @on-user-error="onUserHasError"
          >
          </booking-edit>

          <booking-show v-else :booking="booking">
            <booking-buttons :booking="booking"></booking-buttons>
          </booking-show>
        </template>
      </parking-common>
    </v-card>
  </v-dialog>
</template>

<script>
import reservationService from '@/services/reservationService';
import manageErrorService from '@/services/manageErrorService';
import ParkingCommon from '@/components/commons/ParkingCommon';
import BookingShow from '@/components/private/booking/BookingShow';
import BookingEdit from '@/components/private/booking/BookingEdit';
import BookingButtons from '@/components/private/booking/BookingButtons';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import Advice from '@/components/commons/Advice';

export default {
  name: 'ReservationDetail',
  components: {
    [ParkingCommon.name]: ParkingCommon,
    [BookingShow.name]: BookingShow,
    [BookingEdit.name]: BookingEdit,
    [BookingButtons.name]: BookingButtons,
    [Advice.name]: Advice
  },
  props: {
    bookingSelected: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      visible: true,
      showingReservationEdit: false,
      parking: {},
      booking: {},
      userErrorText: '',
      userHasErrors: false
    };
  },
  watch: {
    visible: function (value) {
      if (!value) {
        this.$emit('on-bottom-sheet-closed', {});
      }
    }
  },
  created() {
    this.load(this.parking.id);
    EventBus.$on(keys.showReservationDetail, this.showReservationEdit);
    EventBus.$on(keys.closeReservationDetail, this.closeReservationEdit);
  },
  destroyed() {
    EventBus.$off(keys.showReservationDetail, this.showReservationEdit);
    EventBus.$off(keys.closeReservationDetail, this.closeReservationEdit);
  },
  methods: {
    async load() {
      let params = {
        id: this.bookingSelected
      };
      let results = await reservationService.get(params);

      if (results.error) {
        manageErrorService.handle(results.data);
        return false;
      }

      this.booking = {
        id: this.bookingSelected,
        externalId: results.data.externalId,
        startLocal: results.data.startLocal,
        endLocal: results.data.endLocal,
        price: results.data.price,
        maxAvailabilityLocal: results.data.maxAvailabilityLocal,
        closingTime: results.data.closingTimeLocal,
        reopeningTime: results.data.reopeningTimeLocal,
        blockAccessOnClosingTime: results.data.parking.blockAccessOnClosingTime,
        hourPriceWithCurrency: results.data.hourPriceWithCurrency,
        minuteExtraPriceWithCurrency:
          results.data.parking.minuteExtraPriceWithCurrency,
        status: results.data.status,
        type: results.data.type,
        tagSelected: results.data.tagSelected,
        plate: results.data.plate,
        spotName: results.data.spotName,
        isFree: results.data.parking.isFree,
        hasSpotAssignation: results.data.parking.type === 'SENSORED',
        isFacility: results.data.parking.isFacility,
        accessCode: results.data.accessCode
      };

      this.parking = results.data.parking;
    },
    showReservationEdit() {
      this.showingReservationEdit = true;
    },
    closeReservationEdit() {
      this.showingReservationEdit = false;
    },
    onUserHasError(params) {
      this.userHasErrors = true;
      this.userErrorText = params.error;
    },
    solveUserError() {
      if (this.userErrorText === 'showErrorNoTags') {
        this.$router.push({ path: this.$i18n.t('urlTeletac') });
        return;
      }

      if (this.userErrorText === 'showErrorNotActived') {
        this.$router.push({ path: this.$i18n.t('urlRegister') });
        return;
      }

      if (this.userErrorText === 'showErrorNoBalance') {
        this.$router.push({ path: this.$i18n.t('urlBuy') });
      }
    }
  }
};
</script>
